import { createTheme } from '@mui/material/styles';
import { hover, primaryBlack } from './color';

export const theme = createTheme({
  palette: {
    primary: {
      main: hover,
    },
    text: {
      primary: primaryBlack,
    },
  },
  transitions: {
    duration: {
      leavingScreen: 0,
    },
  },
  typography: {
    fontSize: 14,
    h1: {
      fontSize: '18px',
      fontWeight: 700,
      letterSpacing: 0,
      lineHeight: 1.15,
    },
  },
});
